import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import t from "./translations";
import type { ObjectTypeMergePreview, RegionMergePreview } from "./schemas";

function cascadeTotal(region: RegionMergePreview): number {
  return Object.values(region.cascade_counts).reduce((sum, n) => sum + n, 0);
}

type Column = {
  label: string;
  align?: "right";
  value: (region: RegionMergePreview) => number | string;
};

const COLUMNS: Column[] = [
  { label: t.RegionColumn, value: (r) => r.region },
  { label: t.ReassignColumn, align: "right", value: (r) => r.image_object_type_reassign_count },
  { label: t.ConflictsColumn, align: "right", value: (r) => r.image_object_type_conflict_count },
  { label: t.DatasetColumn, align: "right", value: (r) => r.dataset_meta_count },
  { label: t.DefectDatasetColumn, align: "right", value: (r) => r.defect_dataset_meta_count },
  { label: t.TypeConversionColumn, align: "right", value: (r) => r.dataset_type_conversion_count },
  { label: t.ClientMapColumn, align: "right", value: (r) => r.client_object_type_map_count },
  { label: t.DpPowerMapColumn, align: "right", value: (r) => r.dppower_map_count },
  { label: t.CascadeColumn, align: "right", value: cascadeTotal },
];

type Props = {
  preview: ObjectTypeMergePreview;
};

export default function PreviewSummaryTable({ preview }: Props) {
  return (
    <Box>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {COLUMNS.map((col) => (
                <TableCell key={col.label} align={col.align}>
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {preview.regions.map((region) => (
              <TableRow
                key={region.region}
                sx={{
                  "&:nth-of-type(odd)": {
                    backgroundColor: "action.hover",
                  },
                }}
              >
                {COLUMNS.map((col) => (
                  <TableCell key={col.label} align={col.align}>
                    {col.value(region)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
